import { useState, useContext } from 'react';
import Loading from '../../templates/UI/Loading/Loading';
import { SystemMessageContext } from '../../context/SystemMessageContext';
import NotesLog from '../NotesLog/NotesLog';
import callAPI from '../../helpers/callAPI';
import useCallApi from '../../hooks/useCallApi';
import moment from 'moment';
import Advertiser from '../../templates/Advertiser/Advertiser';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';
import CampaignPitch from './CampaignPitch';
import StatusSelect from './StatusSelect';
import { useAuth, useProtectedContent } from '../../context/AuthContext';

export default function AdvertiserRatePitchContent({ ratePitchId, closeModal }) {
    const auth = useAuth()

    const { showSystemMessage } = useContext(SystemMessageContext)
    const [campaign, setCampaign] = useState('')
    const [saveNeeded, setSaveNeeded] = useState(false)
    const [selectedToDelete, setSelectedToDelete] = useState(false)

    const showDelete = useProtectedContent(auth.permissions, 'rate_pitch_delete')

    const { data, setData, dataLoaded, refetch } = useCallApi(`advertisers/${ratePitchId}/ratePitch`, 'GET', {}, [])

    const addCampaignPitch = async () => {
        if (saveNeeded) {
            showSystemMessage('error', 'Please save your changes before adding a new campaign. This will prevent data loss.')
            return
        }
        if (!campaign) {
            showSystemMessage('error', 'Please select a campaign to add')
            return
        }
        const result = await callAPI(`advertisers/ratepitch/${data.pitch.id}/campaign/${campaign}`, 'POST', {})
        if (result.success) {
            showSystemMessage('success', 'Campaign added successfully')
            refetch()
        } else {
            showSystemMessage('error', result.message || 'An error occurred while adding the campaign')

        }
    }

    const saveCampaginPitches = async (e) => {
        // Find the form element
        const form = document.querySelector('.campaign-pitch-form');
        if (!form) return;

        // Gather all inputs with a data attribute for mapping
        const inputs = form.querySelectorAll('input[data-campaignpitch-index][data-rate-name]');

        // Clone the campaignPitches array to avoid mutating state directly
        const updatedCampaignPitches = data.pitch.campaignPitches.map(cp => ({
            ...cp,
            rates: cp.rates.map(r => ({ ...r }))
        }));

        // Update proposedRate values from the form inputs
        inputs.forEach(input => {
            const cpIndex = parseInt(input.getAttribute('data-campaignpitch-index'), 10);
            const rateName = input.getAttribute('data-rate-name');
            const affiliateId = input.getAttribute('data-affiliate-id');
            const value = input.value;
            console.log({ cpIndex, rateName, affiliateId, value });

            const cp = updatedCampaignPitches[cpIndex];
            if (!cp) return;
            // Find the rate by name and affiliate (if present)
            const rate = cp.rates.find(r =>
                r.name === rateName &&
                ((affiliateId && r.affiliate && String(r.affiliate.id) === affiliateId) ||
                    (!affiliateId && (!r.affiliate || !r.affiliate.id)))
            );
            if (rate) {
                rate.proposedRate = value;
            }
        });

        const result = await callAPI(
            `advertisers/ratepitch/${ratePitchId}/campaignPitches`,
            'PUT',
            { campaignPitches: updatedCampaignPitches }
        );
        if (result.success) {
            showSystemMessage('success', 'Campaign pitches saved successfully');
            setSaveNeeded(false);
            refetch();
        } else {
            showSystemMessage('error', result.message || 'An error occurred while saving the campaign pitches');
        }
    }

    const handleDelete = () => {
        callAPI(`advertisers/ratepitch/${ratePitchId}`, 'DELETE')
            .then(result => {
                if (result["success"] === true) {
                    showSystemMessage('success', result.message);
                    closeModal()
                }
                else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                }
            })
            .catch((error) => {
                showSystemMessage('error', 'An error occurred while deleting the rate pitch.')
            })
    }

    return (
        <div className="card">
            <div className="card-header">Rate Pitch</div>
            <div className="alert alert-info m-3">
                Page Link: <Link to={`/advertisers/ratePitch/${ratePitchId}`}>{`${process.env.REACT_APP_PORTAL_URL}/advertisers/ratePitch/${ratePitchId}`}</Link>
                <span className='ml-3'>
                    <CopyToClipboard text={`${process.env.REACT_APP_PORTAL_URL}/advertisers/ratePitch/${ratePitchId}`}>
                        <button type="button" className="btn btn-outline-primary shadow-none" size="sm">
                            <FontAwesomeIcon icon="copy" />
                        </button>
                    </CopyToClipboard>
                </span>
            </div>
            {dataLoaded ? (
                <div className="m-3">
                    <div className="row">
                        <div className="col-xl-6">
                            {dataLoaded && (
                                <div className="d-flex border rounded mb-3 justify-content-between">
                                    <div className="mx-2 p-2 d-flex align-items-center"><Advertiser id={data.pitch.advertiser.id} name={data.pitch.advertiser.name} /></div>
                                    <div className="mx-2 border-left p-2"><strong>{data.pitch.admin.name}</strong><div className="text-secondary">{moment(data.pitch.db_date).utc().format('YYYY-MM-DD HH:mm')}</div></div>
                                    <div className="mx-2 border-left p-2"><strong>{data.pitch.status.name}</strong><div className="text-secondary">{moment(data.pitch.status.date).utc().format('YYYY-MM-DD HH:mm')}</div></div>
                                </div>
                            )}
                            <NotesLog uri={`advertisers/ratepitch`} id={data.pitch.id} pitchStatus={data.pitch.status} isPitch={true} advertiserId={data.pitch.advertiser.id} />
                        </div>
                        <div className="col-xl-6">
                            {(data.pitch.status.code !== 'D' && data.pitch.status.code !== 'A' && data.pitch.status.code !== 'C' && data.pitch.status.code !== 'X') && (
                                <div className="d-flex w-100 border rounded mb-3 justify-content-between p-2 align-items-center">
                                    <select className="form-control form-control-sm" onChange={(e) => { setCampaign(e.target.value) }}>
                                        <option value="">Select Campaign</option>
                                        {data.pitch.campaigns.map((c) => {
                                            //if the campaign is already added, skip it 
                                            if (data.pitch.campaignPitches.find(cp => cp.id === c.id)) {
                                                return null;
                                            }
                                            return (
                                                <option key={c.id} value={c.id}>{c.name} ({c.id})</option>
                                            )
                                        }
                                        )}
                                    </select>
                                    <Button className="btn btn-sm ml-2" color='primary' onClick={addCampaignPitch}>Add</Button>
                                </div>
                            )}
                            <div className="d-flex justify-content-between p-1 align-items-center flex-column">
                                <div className="w-100 d-flex justify-content-between align-items-center p-2 border-bottom">
                                    <div className="w-75">
                                        <strong>Campaigns</strong>
                                    </div>
                                    {data.pitch.status.code !== 'A' && data.pitch.status.code !== 'C' && data.pitch.status.code !== 'X' && (
                                        <div className="">
                                            <Button className="btn" color='primary' onClick={() => saveCampaginPitches()}>Save</Button>
                                        </div>
                                    )}
                                </div>
                                <form className="w-100 campaign-pitch-form">
                                    {data.pitch.campaignPitches.map((cp, index) => {
                                        return (
                                            <CampaignPitch ratePitchId={ratePitchId} refetch={refetch} key={cp.id} order={1000 - (index * 20)} campaignPitch={cp} campaign={data.pitch.campaigns.find(c => c.id === cp.id)} data={data} setData={setData} campaignPitchIndex={index} status={data.pitch.status} setSaveNeeded={setSaveNeeded} />
                                        )
                                    }
                                    )}
                                </form>
                            </div>
                            {data.pitch.status.code !== 'A' && data.pitch.status.code !== 'C' && data.pitch.status.code !== 'X' && (
                                <StatusSelect status={data.pitch.status} ratePitchId={data.pitch.id} closeModal={closeModal} saveNeeded={saveNeeded} advertiserId={data.pitch.advertiser.id} data={data} refetch={refetch} />
                            )}

                            <div className='mt-3 d-flex justify-content-end'>
                                {showDelete && (selectedToDelete ? <button className="btn btn-danger" onClick={handleDelete}>Confirm Delete Rate Pitch</button> : <button className="btn btn-outline-danger" onClick={() => setSelectedToDelete(true)}>
                                    Delete Rate Pitch
                                </button>)}
                            </div>
                        </div>
                    </div>
                    <div>
                        {/* {data.reversalRequest.status_value !== 'A' &&
                                (!confirmDelete ?
                                    <button className="btn btn-outline-danger" onClick={() => { setConfirmDelete(true) }}>Delete</button>
                                    :
                                    <button className="btn btn-danger" onClick={() => { deleteReversalRequest() }}>Confirm Delete</button>
                                )
                            } */}

                    </div>
                </div>
            ) : (
                <Loading />
            )}
        </div>
    )
}